import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import {
  Box,
  RadioGroup,
  Select,
  MenuItem,
  TextField,
  Tooltip,
  FormControl,
  InputLabel,
  Grid,
  Autocomplete,
  Button,
  FormControlLabel,
  Checkbox,
  Container,
  ListItemText,
  IconButton
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { Stack, Paper, Divider, Typography } from "@mui/material";
import { motion } from "framer-motion";
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";

import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import AddBoxIcon from "@mui/icons-material/AddBox";
import configServ from "../../services/config";
import AlertDialog from "../../Components/AlertDialog/AlertDialog";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import BatchCard from "./BatchCard";
import BatchTable from "./BatchTable";



//FUNCTION
const BatchPage = () => {
  //#region code
  const { user_id, company_id, noRoomService } = useSelector((state) => state.GlobalVariables);
  const dispatch = useDispatch();
  const formDataInitial = {
    item_type: "evening",
    start_date: '',
    end_date: '',
    start_time: '',
    end_time: '',
    status: true,
  };
  const [formData, setFormData] = useState(formDataInitial);
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [superCategoryList, setSuperCategoryList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [hsnList, setHsnList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [companyType, setCompanyType] = useState("product");
  const [hsn, setHsn] = useState("");
  const { company_type } = useSelector((state) => state.admin);

  const [tableData, setTableData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  const [openAddImage, setOpenAddImage] = useState(false);
  const [openAddSize, setOpenAddSize] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [isItemUpdated, setIsItemUpdated] = useState(false);
  const navigate = useNavigate();

  const [isCreate, setIsCreate] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [title, setTitle] = useState('Alert');
  const [dialogContent, setDialogContent] = useState('');
  const [buttonType, setButtonType] = useState(null);
  const [verificationType, setVerificationType] = useState([]);

  const handleOpenDialog = (heading, content, type) => {
    setTitle(heading);
    setDialogContent(content);
    setButtonType(type);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setTitle('Alert');
    setDialogContent('');
    setButtonType(null);
  };

  const handlePopup = () => {
    try {
      setValidationErrors({})
      setIsCreate(!isCreate);
      clear();

    } catch (error) {
      console.log(error);
    }
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormData((state) => ({
      ...state,
      [name]: value,
    }));

  };

  const checkHandler = (e) => {
    const { name, checked } = e.target;
    setFormData((state) => ({
      ...state,
      [name]: checked,
    }));

  };

  const fetchCategory = async () => {
    try {
      //const result = await configServ.getcategoryByBrand({ "brand_id": formData.brand_id });
      const res = await configServ.getcategory({
        "company_id": company_id,
      });
      if (res.status === 200) {
        const result = res.data.filter(x => x.status === 1);
        const categoryResponse = result;
        categoryResponse.forEach((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              category_id: item.categoryid.toString()
            }));
          }
        });
        setCategoryList(categoryResponse);
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const fetchBrand = async () => {
    try {
      const res = await configServ.getBrand({
        "company_id": company_id,
      });
      if (res.status === 200) {
        const result = res.data.filter(x => x.status === 1);
        const brandResponse = result;
        brandResponse.forEach((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              brand_id: item.id.toString()
            }));
          }
        });
        setBrandList(brandResponse);
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const fetchGroup = async () => {
    try {

      const resg = await configServ.getGroup({
        "company_id": company_id,
      });
      if (resg.status === 200) {
        const result = resg.data.filter(x => x.status === 1);
        const groupResponse = result;
        groupResponse.map((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              group_id: item.id
            }));
          }
        });
        setGroupList(groupResponse);
      }
      else {
        setGroupList([]);
      }
      // }
    }
    catch (error) {
      console.log(error);
    }
  };

  // const fetchLocation = async () => {
  //   try {
  //     const result = await configServ.getLocation({
  //       "company_id": company_id,
  //     });
  //     setLocationList(result);
  //   }
  //   catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchVerificationType = async () => {
    try {
      const verificationTypes = await configServ.getVerificationType();
      if (verificationTypes.status === 200) {
        setVerificationType(verificationTypes.data);
      }
      else {
        setVerificationType([]);
      }
    }
    catch (e) {
      console.log(e);
    }
  }


  const fetchUnit = async () => {
    try {
      const res = await configServ.getUnit({
        "company_id": company_id
      });
      if (res.status === 200) {
        const result = res.data.filter(x => x.status === 1);
        const unitResponse = result;
        unitResponse.map((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              unit: item.units_name
            }));
          }
        });
        setUnitList(unitResponse);
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  // const fetchGstDetails = async () => {
  //   try {
  //     const result = await configServ.getGstDetails();
  //     setHsnList(result);
  //   } 
  //   catch (error) {
  //     console.log(error);
  //   }
  // };

  // const fetchHsnCode = (data) => {
  //   data.map((item) => {
  //     setHsnList((state) => [
  //       ...state,
  //       {
  //         label: item.hsncode,
  //         id: item.pk,
  //       },
  //     ]);
  //   });
  // };

  useEffect(() => {
    if (isCreate) {
      //fetchSuperCategory();
      fetchCategory();
      fetchBrand();
      fetchGroup();
      fetchVerificationType();
      fetchUnit();
      //fetchGstDetails();
      //fetchLocation();
      setValidationErrors({});
    }
  }, [isCreate]);

  // useEffect(()=>{
  //     if(formData.brand_id){
  //         fetchCategory();
  //     }
  // },[formData.brand_id]);

  // const fetchVerificationTypeByCategory = async () => {
  //   try {
  //     const dataToSend = {
  //       brand_id: formData.brand_id,
  //       category_id: formData.category_id
  //     }
  //     const res = await configServ.getVerificationTypeByCategory(dataToSend);
  //     if (res.status === 200) {
  //       setFormData((prev) => ({
  //         ...prev,
  //         verification_type: res.data
  //       }));
  //     }
  //   }
  //   catch (e) {
  //     console.log(e);
  //   }
  // }

  // useEffect(() => {
  //   if (formData.category_id && formData.brand_id) {
  //     fetchVerificationTypeByCategory();
  //   }
  // }, [formData.category_id]);



  const handleEdit = async (data) => {
    console.log("handleEdit", data);
    setIsCreate(true);
    setValidationErrors({});
    setCompanyType(data.type);

    const updatedFormData = {
      ...data,
      brand_id: data.brand_id ? data.brand_id.toString() : "",
      category_id: data.category_id ? data.category_id.toString() : "",
      days: data.days ? data.days.split(",") : [], // 👈 string → array
      rate_unit: data.duration ? data.duration.toString() : ""  // 👈 duration → rate_unit
    };

    setFormData(updatedFormData);
    setIsEdit(true);
  };




  const handleSubmit = async () => {
    const itemData = {
      ...formData,

      days: Array.isArray(formData.days) ? formData.days.join(",") : "",
      type: companyType,
      company_id: company_id,
      user_id: user_id,
    };

    const error = await handleFormValidation();
    if (error === false) {
      return false;
    }
    setValidationErrors({});
    if (!isEdit) {
      try {
        const res = await configServ.storeBatch(itemData);
        if (res.status === 200) {
          handleOpenDialog('Success', res.message, 'success');
          clear();
          setIsChanged(!isChanged);
        }
        else {
          handleOpenDialog('Error', res.message || "Failed to add exam.", 'error');
        }
      }
      catch (error) {
        console.log(error);
      }
    }
    else {
      try {
        const res = await configServ.updateBatchs(itemData);
        if (res.status === 200) {
          handleOpenDialog('Success', res.message, 'success');
          clear();
          setIsChanged(!isChanged);
        }
        else {
          handleOpenDialog('Error', res.message || "Failed to update exam.", 'error');
        }
      }
      catch (error) {
        console.log(error);
      }
    }
  };

  const clear = () => {
    setFormData(formDataInitial);
    setIsEdit(false);
    setHsn("");
    setCompanyType("");
    setValidationErrors({});
  };



  const handleFormValidation = async () => {
    const errors = {};
    if (!formData.brand_id) {
      errors.brand_id = "required";
    }
    if (!formData.days) {
      errors.days = "required";
    }
    if (!formData.category_id) {
      errors.category_id = "required";
    }

    if (!formData.item_name) {
      errors.item_name = "required";
    }
    if (!formData.item_code) {
      errors.item_code = "required";
    }

    if (!formData.unit) {
      errors.unit = "required";
    }

    if (!formData.rate_unit) {
      errors.rate_unit = "required";
    }
    if (!formData.start_date) {
      errors.start_date = "required";
    }
    if (!formData.end_date) {
      errors.end_date = "required";
    }
    if (!formData.start_time) {
      errors.start_time = "required";
    }
    if (!formData.end_time) {
      errors.end_time = "required";
    }
    setValidationErrors(errors);
    return Object.values(errors).every((error) => error === "");
  };



  //#endregion

  return (
    <>
      <AlertDialog
        open={dialogOpen}
        setOpen={handleCloseDialog}
        title={title}
        message={dialogContent}
        buttonTitle="Ok"
        buttonType={buttonType}
      />
      <Container>
        <CardHeadMenu
          prefix={"Na"}
          suffix={"Na"}
          title={"Batch"}
          handlePopup={handlePopup}
          isEdit={isEdit}
          create={isCreate}
        />
      </Container>
      {isCreate === true && (
        <Container>

          <motion.div
            style={{
              width: "100%",
              backgroundColor: "#e3f3fc",
              padding: 20,
              borderRadius: "10px",
              border: "none",
            }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1, delay: 0.1 }}
          >
            <Grid
              container
              alignItems="flex-end"
              justifyContent="flex-start"
              spacing={1}
            >
              <Grid item xs={12} md={12} justifyContent={"flex-start"}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bolder" }}>
                  Batch Detail
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  id="brand"
                  options={brandList}
                  getOptionLabel={(option) => option.brand_name}
                  value={
                    brandList.find(
                      (item) => item.id.toString() === formData.brand_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    changeHandler({
                      target: {
                        name: "brand_id",
                        value: newValue?.id.toString() || "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="brand_id"
                      label={<span>Brand<span style={{ color: 'red' }}>*</span></span>}
                      variant="outlined"
                      fullWidth
                      error={!!validationErrors.brand_id}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  id="category"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  options={categoryList}
                  getOptionLabel={(option) => option.categoryname}
                  value={
                    categoryList.find(
                      (item) =>
                        item.categoryid.toString() === formData.category_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    changeHandler({
                      target: {
                        name: "category_id",
                        value: newValue?.categoryid.toString() || "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="category_id"
                      label={<span>Category<span style={{ color: 'red' }}>*</span></span>}
                      variant="outlined"
                      fullWidth
                      error={!!validationErrors.category_id}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="item_name"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  name="item_name"
                  label={<span>Batch Name<span style={{ color: 'red' }}>*</span></span>}
                  variant="outlined"
                  fullWidth
                  value={formData.item_name || ""}
                  onChange={changeHandler}
                  error={!!validationErrors.item_name}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="item_code"
                  name="item_code"
                  label={<span>Batch Code<span style={{ color: 'red' }}>*</span></span>}
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={formData.item_code || ""}
                  onChange={changeHandler}
                  error={!!validationErrors.item_code}
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="itemType">Shift</InputLabel>
                  <Select
                    id="itemType"
                    size="small"
                    sx={{ backgroundColor: "white" }}
                    name="item_type"
                    value={formData.item_type || ""}
                    onChange={changeHandler}
                    label="Item Type*"
                  >
                    <MenuItem value="evening">Evening</MenuItem>
                    <MenuItem value="morning">Morning</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="itemDescription"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  name="description"
                  label={<span>Batch Description</span>}
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={2}
                  value={formData.description || ""}
                  onChange={changeHandler}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <Autocomplete
                  id="unit"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  options={unitList}
                  getOptionLabel={(option) => option.units_name}
                  value={
                    unitList.find(
                      (item) => item.units_name === formData.unit
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    changeHandler({
                      target: {
                        name: "unit",
                        value: newValue?.units_name || "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="unit"
                      label={<span>Unit<span style={{ color: 'red' }}>*</span></span>}
                      variant="outlined"
                      fullWidth
                      error={!!validationErrors.unit}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="unitPrice"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  name="rate_unit"
                  label={<span>Time Duration<span style={{ color: 'red' }}>*</span></span>}
                  type="number"
                  variant="outlined"
                  fullWidth
                  value={formData.rate_unit || ""}
                  onChange={changeHandler}
                  error={!!validationErrors.rate_unit}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  type="date"
                  label="Start Date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={changeHandler}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  error={!!validationErrors.start_date}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  type="date"
                  label="End Date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={changeHandler}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  error={!!validationErrors.end_date}
                />
              </Grid>
              <LocalizationProvider dateAdapter={AdapterDayjs}>

                <Grid item xs={12} md={3}>
                  <TimePicker
                    label="Start Time"
                    value={formData.start_time ? dayjs(formData.start_time, "HH:mm") : null}
                    onChange={(newValue) =>
                      changeHandler({
                        target: {
                          name: "start_time",
                          value: dayjs(newValue).format("HH:mm")
                        }
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        sx={{ backgroundColor: "white" }}
                        error={!!validationErrors.start_time}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TimePicker
                    label="End Time"
                    value={formData.end_time ? dayjs(formData.end_time, "HH:mm") : null}
                    onChange={(newValue) =>
                      changeHandler({
                        target: {
                          name: "end_time",
                          value: dayjs(newValue).format("HH:mm")
                        }
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        sx={{ backgroundColor: "white" }}
                        error={!!validationErrors.end_time}
                      />
                    )}
                  />
                </Grid>

              </LocalizationProvider>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="days-label">Days</InputLabel>
                  <Select
                    labelId="days-label"
                    id="days"
                    multiple
                    name="days"
                    sx={{ backgroundColor: "white" }}

                    value={formData.days || []}   // 👈 अब हमेशा array
                    onChange={(e) =>
                      setFormData({ ...formData, days: e.target.value })
                    }
                    renderValue={(selected) => selected.join(', ')}
                    error={!!validationErrors.days}
                  >
                    {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => (
                      <MenuItem key={day} value={day}>
                        <Checkbox checked={formData.days?.includes(day)} />
                        <ListItemText primary={day} />
                      </MenuItem>
                    ))}
                  </Select>

                </FormControl>
              </Grid>




              <Grid container my={2} spacing={1} justifyContent="space-between" alignItems="center">
                <Grid item xs={6} md={3}>
                  <FormControlLabel
                    name="status"
                    control={<Checkbox checked={Boolean(formData.status) || false} />}
                    onChange={checkHandler}
                    label="Status"
                    style={{ marginRight: "20px" }}
                  />
                </Grid>

                {/* Buttons ek hi row me */}
                <Grid item xs={12} md={4}>
                  <Grid container spacing={2} justifyContent="flex-end">
                    <Grid item>
                      <Button
                        color="secondary"
                        onClick={clear}
                        variant="contained"
                        title={"Reset"}
                        startIcon={<RotateLeftIcon />}
                      >
                        Reset
                      </Button>
                    </Grid>

                    <Grid item>
                      <Button
                        color={isEdit ? "success" : "primary"}
                        onClick={handleSubmit}
                        variant="contained"
                        startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                      >
                        {isEdit ? "Update" : "Save"}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>


            </Grid>
          </motion.div>
        </Container>
      )}

      <Container>
        <BatchTable
          handleEdit={handleEdit}
          setIsChanged={setIsChanged}
          isChanged={isChanged}
        />
      </Container>
    </>
  );
};
export default memo(BatchPage);
